//deprecated but leave it for backword compatibility
module.exports.core=require("./core");

//live apis
module.exports=require("./core");
module.exports.interfaces = require("./interfaces");



//////////////////
// WEBPACK FOOTER
// ./~/csvtojson/libs/csv2json.js
// module id = 815
// module chunks = 0